module.exports = __webpack_public_path__ + "static/media/img_stp_card_discover.81bdb2aa.png";